import React from "react";

export const tickStyle = { fill: "rgb(var(--muted))", fontSize: 10, fontFamily: "IBM Plex Mono" };

export function ChartTip({ active, payload, label, formatter }) {
  if (!active || !payload?.length) return null;
  return (
    <div className="bg-surface border border-border-strong px-3 py-2 text-xs rounded-sm shadow-lg">
      <div className="text-[10px] uppercase tracking-widest text-muted mb-1">{label}</div>
      {payload.map((p, i) => (
        <div key={i} className="flex items-center gap-2 font-mono-tabular">
          <span className="w-2 h-2" style={{ background: p.color || p.payload?.fill }} />
          <span className="text-muted">{p.name}</span>
          <span className="ml-auto font-semibold">{formatter ? formatter(p.value, p) : p.value?.toLocaleString()}</span>
        </div>
      ))}
    </div>
  );
}
